import {
  loginService,
  userService,
  appointmentService,
  shiftService,
  agoraService,
  appService,
  doctorService,
  rxService,
} from 'services';

export interface Apis {
  login: any,
  logout: any,
  updateUser: any,
  verifyOtp: any,
  checkWhatsAppConsent: any,
  whatsAppOptIn: any,
  whatsAppOptOut: any,
  getPrescriptions: any,
  getPrescriptionPdf: any,
  diagnosticOrder: any,
  getFaqs: any;
  getEnabledFeatures: any,
  getEnabledFeaturesForAll: any,
  getAggregateDoctors: any,
  getClinics: any,
  getClinicDetails: any;
  getVcPrice: any,
  getDoctorDetails: any,
  searchDoctor: any,
  getAppointments: any,
  getAppointment: any,
  bookAppointment: any;
  bookZeroFeeTeleConsult: any;
  getTeleConsultSession: any;
  getLatestTeleConsultPayment: any;
  initiateTeleConsultPayment: any;
  getTeleConsultPricing: any;
  deleteAppointment: any;
  getProfileToken: any,
  getReceipt: any;
  getClinicSchedule: any,
  getShifts: any,
  addShift: any,
  editShift: any,
  deleteShift: any,
  updateShift: any,
  getOnlineSchedule: any,
  getNextAvailableSlot: any,
  getTeleSession: any;
  getDashboardData: any;
  getUserPatients: any;
  createNewPatient: any;
  getDiscountBanner: any;
  getCartItems: any;
  getUserDetailsFromToken: any;
}

export default {
  login: loginService.login,
  logout: loginService.logout,
  verifyOtp: loginService.verifyOtp,
  checkWhatsAppConsent: loginService.checkWhatsappConsentStatus,
  whatsAppOptIn: loginService.whatsappOptIn,
  whatsAppOptOut: loginService.whatsappOptOut,
  updateUser: userService.updateUser,
  getPrescriptions: userService.getPrescriptions,
  getPrescriptionPdf: userService.getPdfUrl,
  diagnosticOrder: userService.diagnosticOrder,
  getAggregateDoctors: doctorService.getAggregateDoctors,
  getClinics: doctorService.getClinics,
  getClinicDetails: doctorService.getClinicDetails,
  getVcPrice: doctorService.getVcPrice,
  getDoctorDetails: doctorService.getDoctorDetails,
  searchDoctor: doctorService.searchDoctor,
  getEnabledFeatures: appService.featuresEnabled,
  getEnabledFeaturesForAll: appService.featuresEnabledAllDoctors,
  getFaqs: appService.getFaqs,
  getDashboardData: userService.getDashboardData,
  getAppointments: appointmentService.getAppointments,
  getAppointment: appointmentService.getAppointment,
  bookAppointment: appointmentService.bookAppointment,
  bookZeroFeeTeleConsult: appointmentService.bookZeroFeeTeleConsult,
  getTeleConsultSession: appointmentService.getTeleConsultSession,
  getLatestTeleConsultPayment: appointmentService.getLatestTeleConsultPayment,
  initiateTeleConsultPayment: appointmentService.initiateTeleConsultPayment,
  getTeleConsultPricing: appointmentService.getTeleConsultPricing,
  deleteAppointment: appointmentService.deleteAppointment,
  getProfileToken: appointmentService.getProfileToken,
  getReceipt: appointmentService.getReceipt,
  getClinicSchedule: shiftService.getClinicSchedule,
  getShifts: shiftService.getShifts,
  addShift: shiftService.addShift,
  editShift: shiftService.editShift,
  deleteShift: shiftService.deleteShift,
  updateShift: shiftService.updateShift,
  getNextAvailableSlot: shiftService.getNextAvailableSlot,
  getOnlineSchedule: shiftService.getOnlineSchedule,
  getTeleSession: agoraService.getTeleSession,
  getUserPatients: userService.getUserPatients,
  createNewPatient: userService.createNewPatient,
  getDiscountBanner: rxService.getDiscountBanner,
  getCartItems: rxService.getCartItems,
  getUserDetailsFromToken: userService.getUserDetailsFromToken,
} as Apis;

